import { Form, Input } from 'antd';

import { useCreateUser } from '../../hooks';
import { Card, FormActions, PageHeader } from '../../components';
import { ROUTE_URLS } from '../../routes';
import { useI18n } from '../../i18n';
import { ALL_EMPLOYEE_PAGE_KEYS, PagesCard } from './PagesCard';

export const CreateUser = () => {
  const { t } = useI18n();
  const { isLoading, mutateAsync: createUser } = useCreateUser();
  const onFinish = values => {
    createUser(values);
  };
  const required = field => [{ required: true, message: t('validation.required', { field }) }];

  return (
    <div className='wm-form-page wm-form-page--narrow'>
      <PageHeader
        backTo={ROUTE_URLS.USERS}
        backLabel={t('nav.users')}
        title={t('users.createTitle')}
        subtitle={t('users.createSubtitle')}
      />
      <Form
        name='users'
        layout='vertical'
        onFinish={onFinish}
        requiredMark={false}
        initialValues={{ pages: ALL_EMPLOYEE_PAGE_KEYS }}
      >
        <Card>
          <Form.Item label={t('users.login')} name='login' rules={required(t('users.login'))}>
            <Input placeholder={t('users.loginPlaceholder')} autoComplete='off' autoFocus />
          </Form.Item>
          <Form.Item
            label={t('users.email')}
            name='email'
            extra={t('users.emailHint')}
            rules={[{ type: 'email', message: t('users.emailInvalid') }]}
          >
            <Input placeholder={t('users.emailPlaceholder')} autoComplete='off' />
          </Form.Item>
          <Form.Item
            label={t('users.password')}
            name='password'
            rules={required(t('users.password'))}
            style={{ marginBottom: 4 }}
          >
            <Input.Password placeholder={t('users.passwordPlaceholder')} autoComplete='new-password' />
          </Form.Item>
        </Card>
        <PagesCard />
        <FormActions cancelTo={ROUTE_URLS.USERS} submitting={isLoading} />
      </Form>
    </div>
  );
};
